module.exports = __webpack_public_path__ + "img/base_divers_velo_electrique.e3383550.svg";